/* src/app/shared/components/ag-date-picker/date-month-box/date-month-box.component.scss */
.custom-datepicker {
  position: absolute;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #222222;
  overflow: hidden;
  width: 286px;
}
.placement-top {
  bottom: 0px;
}
.placement-bottom {
  top: 0px;
}
.placement-right {
  right: 101%;
}
.placement-zero-right {
  right: 0%;
}
.placement-zero-left {
  left: 0%;
}
.placement-left {
  left: 101%;
}
.placement-top-left {
  top: 0px;
  left: 101%;
}
.placement-top-right {
  top: 0px;
  right: 101%;
}
.placement-bottom-left {
  bottom: 52px;
  left: 101%;
}
.placement-bottom-right {
  bottom: 52px;
  left: 101%;
}
.placement-bottom-just-left {
  right: 0;
}
.header {
  width: 100%;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.image {
  cursor: pointer;
  width: 16px;
  height: 16px;
}
.label {
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  color: #222222;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.divider {
  height: 1px;
  width: 100%;
  background-color: #dfdfdf;
}
.calendar {
  position: relative;
  padding: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
}
.selected-month {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  height: 51px;
  width: 84px;
  background-color: #222222;
  color: #ffffff;
  cursor: pointer;
  font-family: "Poppins-SemiBold";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
}
.month {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 51px;
  width: 84px;
  background-color: transparent;
  color: #222222;
  cursor: pointer;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
}
.month:hover {
  border-radius: 12px;
  background-color: #f2f2f2;
  color: #222222;
}
.disabled {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  height: 51px;
  width: 84px;
  background-color: transparent;
  color: #a6a6a6;
  cursor: default;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
}
.first-date {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
  height: 51px;
  width: 84px;
  background-color: #222222;
  color: #ffffff;
  cursor: pointer;
  font-family: "Poppins-SemiBold";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
}
.last-date {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  height: 51px;
  width: 84px;
  background-color: #222222;
  color: #ffffff;
  cursor: pointer;
  font-family: "Poppins-SemiBold";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
}
.in-between {
  background-color: #e4d7f3;
}
.button-area {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 8px;
  padding: 16px;
}
/*# sourceMappingURL=date-month-box.component.css.map */
